



























































































































































































































































import BaseCard from '../../_components/BaseCard.vue';
import BaseComponent from '@/core/base.component';
import { Prop, Vue, Component } from 'vue-property-decorator';
import { DeliverySpaceDto, DeliverySpaceListDto } from '../../../dto';
import AmenityService from '../../../services/amenity.service';
import DeliverySpaceService from '../../../services/delivery-space.service';
import { Pagination } from '@/common';

import DeliverySpaceDetailContractList from '../../delivery-space/components/DeliverySpaceDetailContractList.vue';

@Component({
  name: 'CompanyDistrictDeliverySpaceList',
  components: {
    BaseCard,
    DeliverySpaceDetailContractList,
  },
})
export default class CompanyDistrictDeliverySpaceList extends BaseComponent {
  private deliverySpaceList: DeliverySpaceDto[] = Array<DeliverySpaceDto>();
  private deliverySpaceListDto = new DeliverySpaceListDto();
  private deliverySpaceDto = new DeliverySpaceDto();
  private deliverySpaceListCount = 0;
  private pagination = new Pagination();

  private prevNo = null;
  private nextNo = null;

  // 타입 공간 리스트
  findAll(isPagination?: boolean) {
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 6;
    this.deliverySpaceListDto.companyDistrictNo = parseInt(
      this.$route.params.id,
    );

    DeliverySpaceService.findAll(
      this.deliverySpaceListDto,
      this.pagination,
    ).subscribe(res => {
      this.deliverySpaceList = res.data.items;
      this.deliverySpaceListCount = res.data.totalCount;
    });
  }

  // 타입 상세 보기
  findOne(typeNo: number) {
    DeliverySpaceService.findOne(typeNo).subscribe(res => {
      if (res) {
        this.deliverySpaceDto = res.data;
        this.findOnePrevious(typeNo);
        this.findOneNext(typeNo);
        this.$root.$emit('find_contract_list', typeNo);
      }
    });
  }

  // 이전 타입 보기
  findOnePrevious(typeNo: number) {
    DeliverySpaceService.findModalPrevious(typeNo).subscribe(res => {
      if (res) {
        this.prevNo = res.data;
      }
    });
  }

  // 다음 타입 보기
  findOneNext(typeNo: number) {
    DeliverySpaceService.findModalNext(typeNo).subscribe(res => {
      if (res) {
        this.nextNo = res.data;
      }
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  created() {
    this.findAll();
  }

  mounted() {
    this.$root.$on('delivery_space_create', () => {
      this.findAll(false);
    });
  }
}
